import React from 'react';
import { Animated, StyleSheet, Pressable, Easing,  } from 'react-native';
import { ConnectionOrd, ConnectionMkt} from '../~Utilities/Connection';
import Utilities from '../~Utilities/Utilities';

var oSettAlt     : Array<any>  | null;
const DEFAULT_WIDTH   = 350;
const DEFAULT_OPACITY = 0.4;

const AnimatedPressable = Animated.createAnimatedComponent(Pressable);
//const AnimatedTWF       = Animated.createAnimatedComponent(TouchableWithoutFeedback);

export default class ModalEx extends React.Component 
 {
    
   public static oModalEx : ModalEx | null;

    ReOrder()
    {
      if (oSettAlt != null)
        {
        Utilities.Sendlog("reordering...");  
        //oSettings = oSettAlt;
  
        let   oStoreLocal = new Map();
          
        for (let i = 0; i < oSettAlt.length; i++)
            oStoreLocal.set(oSettAlt[i].token,
                            ConnectionMkt.oStore.get (oSettAlt[i].token));
  
  
        ConnectionMkt.oStore = oStoreLocal;
        //oSettAlt  = null;
        }
    }
  
  /*   -------------------------------------------------------------------   */

    CloseModal(bCommit = true, 
               bClose  = true)
    {
    if (bCommit && oSettAlt != null)
      {
      //this.ReOrder();

      let   oStoreLocal = new Map();
          
      for (let i = 0; i < oSettAlt.length; i++)
          oStoreLocal.set(oSettAlt[i].token,
                          ConnectionMkt.oStore.get (oSettAlt[i].token));

  
      //alert("apply reorder 0");
      ConnectionOrd.ApplyReOrder(oStoreLocal, oSettAlt);                          
      //ConnectionOrd.oSettings = oSettAlt;
      //ConnectionOrd.SaveSettings()
      //this.forceUpdate();
      }
  
    oSettAlt  = null;
  
    if (bClose == true)
      this.Hide();
    }
  
  /*   -------------------------------------------------------------------   */
    
   Show()
   {
    

    //alert("show : " + this.state.visible);  
    
    this.setState({visible:true,
                   });

    //this.state.AnimLeft.setValue(-DEFAULT_WIDTH);

    //this.forceUpdate
    this.SlideIn();
   }

  /*   -------------------------------------------------------------------   */

    Hide()
    {
    this.setState({visible:false})
    this.SlideOut();
    }

  /*   -------------------------------------------------------------------   */

    HideNoAnimation()
    {
    this.setState({visible:false})
    }

  /*   -------------------------------------------------------------------   */

    Toggle()
    {
    if (this.state.visible == true)
      this.Hide();
    else
      {
      this.Show();
      }
    //this.setState({visible:!this.state.visible})
    }

  /*   -------------------------------------------------------------------   */

    state = {visible:null, 
             AnimLeft: new Animated.Value(-DEFAULT_WIDTH), 
             AnimOp: new Animated.Value(0)};

  /*   -------------------------------------------------------------------   */

   
    constructor(props)
    {
    super(props);

    this.state       = {visible:null, 
                        AnimLeft:new Animated.Value(-DEFAULT_WIDTH),
                        AnimOp: new Animated.Value(0)};

    this.Show            = this.Show.bind(this);
    this.Hide            = this.Hide.bind(this);
    this.HideNoAnimation = this.HideNoAnimation.bind(this);
    this.ReOrder         = this.ReOrder.bind(this);
    this.CloseModal      = this.CloseModal.bind(this);

    ModalEx.oModalEx = this;
    }

  /*   -------------------------------------------------------------------   */

    componentDidMount() 
    {
    }

    componentWillUnmount() 
    {
    }

  /*   -------------------------------------------------------------------   */

   SlideIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(this.state.AnimLeft, {
      toValue: -40,
      duration: 300,
      easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();

    Animated.timing(this.state.AnimOp, {
      toValue: DEFAULT_OPACITY,
      duration: 300,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();    
  };

  /*   -------------------------------------------------------------------   */

  SlideOut = () => {
    // Will change fadeAnim value to 0 in 3 seconds
    Animated.timing(this.state.AnimLeft, {
      toValue: -DEFAULT_WIDTH,
      duration: 300,
      useNativeDriver:true
    }).start(()=>{ this.setState({visible:false}) });

    Animated.timing(this.state.AnimOp, {
      toValue: 0,
      duration: 300,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();        
  };

  /*   -------------------------------------------------------------------   */

  render() 
   {
    if (!this.state.visible) 
    return(null);
    else  
    return(
        <>
        <AnimatedPressable
        onPress={this.Hide}
        style={{justifyContent:'center', alignItems:'center', position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'black', opacity: this.state.AnimOp, top:0, bottom:0}}
        />
        
        
      {/* <Modal onBackdropPress={()=>this.Hide()} 
             isVisible={this.state.visible}
             backdropOpacity={0.0}
             style={{position:'absolute', left:0, right:0, top:0, bottom:0, alignItems:'center', alignContent:'center', justifyContent:'center'}}
             backdropColor={'transparent'}
             > */}

         {/* {this.props.children} */}
         {/* <TouchableOpacity onPress={this.Hide} style={{ backgroundColor:'white', alignSelf:'center', justifyContent:'center', borderRadius:10, width:300, height:200, }}> */}
            {/* <Text style={{backgroundColor:'white', fontSize:16, textAlign:'center'}}>{"sdsdsd"}</Text> */}
         {/* </TouchableOpacity> */}

      {/* </Modal> */}

        {/* <Animated.View 
        style={
            {
            //position:'absolute',
            //backgroundColor:'white',
            //width:100, height:100,
            //alignSelf:'center', 
            //zIndex:201,
            //alignSelf:'center',
            //alignItems:'center',
            
            
            //top:(Dimensions.get ('window').height / 2 - 150),
            //justifyContent:'center',  
            transform: [{translateX: this.state.AnimLeft}],
            //borderRadius:20
            }}>

        <View style={{width:100, height:300, backgroundColor:'white', borderRadius:20}}></View>

        </Animated.View>
        </AnimatedPressable> */}

        </>
        ); 

   }
}

/*   =====================================================================   */

const styles = StyleSheet.create({

    container_sort_cover: {
      backgroundColor: 'transparent',
      alignSelf:'center',
      width:200,
    },
  
    container_sort: {
      backgroundColor: 'transparent',
      alignSelf:'center',
    },
  
    tile_sort: {
      backgroundColor:'transparent',
      width: '100%',
      height: '100%',
    },
});